import { useLocalization } from "@fluent/react";
import { Alert } from "@narmi/design_system";

import { useCurrentUser } from "../contexts/CurrentUserContext";
import { useUserFeatures } from "../contexts/UserFeaturesContext";

import { useAccountAnnouncementBanner } from "./useAccountAnnouncementBanner";

const AccountAnnouncementBanner = () => {
  const { l10n } = useLocalization();
  const { currentUser } = useCurrentUser();
  const { live_ledger: liveLedgerEnabled } = useUserFeatures();
  const enabled = Boolean(liveLedgerEnabled) && currentUser !== null;
  const { visible, dismiss } = useAccountAnnouncementBanner(
    currentUser?.id?.toString() || "",
    enabled
  );

  if (!enabled) {
    return null;
  }

  return (
    <Alert
      isActive={visible}
      kind="primary"
      icon="sparkle"
      isDismissable
      onUserDismiss={dismiss}
    >
      <div className="fontWeight--bold margin--bottom--m">
        {l10n.getString("live-ledger-account-announcement-title")}
      </div>
      <div>{l10n.getString("live-ledger-account-announcement-message")}</div>
    </Alert>
  );
};

export default AccountAnnouncementBanner;
